module.exports = __webpack_public_path__ + "img/商品详情1-3.a70f1d45.png";